import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import WaiverForm from '@/app/userActivityWaiver/WaiverForm';

import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

import { useActivitiesV2 } from '@/data/activity';
import { useCart } from '@/data/cart';
import { useCheckoutStructure } from '@/data/checkout';

const Waiver = ({ cartId }) => {
  const params = useParams();
  const activities = useActivitiesV2();
  const cart = useCart(params.cartId);
  const navigate = useNavigate();
  const stepKey = params.stepKey;
  const checkoutStructure = useCheckoutStructure(params.cartId);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (activities.isLoading && !activities.data) {
    return null;
  }
  if (cart.isLoading && !cart.data) {
    return null;
  }

  const step = checkoutStructure.data.steps.find((s) => s.stepKey === stepKey);

  const handleSuccess = () => {
    navigate(step.nextStepLink);
  };

  const handleNextStep = () => {
    navigate(step.nextStepLink);
  };

  const handleBack = () => {
    navigate(`/checkout/cart/${cartId}/step/customer`);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>{step.title}</CardTitle>
      </CardHeader>
      <CardContent>
        <WaiverForm
          onSuccess={handleSuccess}
          onNextStep={handleNextStep}
          isComplete={step.isComplete}
          activityId={step.activityId} // TODO: Figure out waiver activity
          onBack={handleBack}
        />
      </CardContent>
    </Card>
  );
};

export default Waiver;
